module.exports = __webpack_public_path__ + "img/5-3.f49ae43d.svg";